import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Card,
    CardContent,
    Checkbox,
    Typography,
    Chip,
    Grid,
    List,
    ListItem,
    Divider,
    Collapse

} from '@material-ui/core';

// import config from '../../config/config.json'



const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    content: {
        marginTop: theme.spacing(2)
    },
    card: {
        width: '100%'
    }
}));

const UsersList = (props) => {
    const { className, ...rest } = props;
    const classes = useStyles();

    const [users, setUsers] = useState([]);

    // console.log('users UsersList',users);

    useEffect(() => {
        // Поулчим списки сессий и пользователей
        // getData();
        // setUsers(prepareApiUsers(props.users))
        setUsers(props.users)
        // console.log('props.users',props.users);
    }, [props.users]);

    const handleChange = userId => event => {
        // console.log('handleChange', event.target.checked, user);
        props.onChange(userId)
        // setChecked(event.target.checked);
    };

    const filterUsers = (couponStateFilterId, customerTypeFilterId) => {
        // console.log('couponStateFilterId,customerTypeFilterId',couponStateFilterId,customerTypeFilterId);
        return customerTypeFilter(couponStateFilter(props.users, couponStateFilterId), customerTypeFilterId)
        // console.log('handleChange', event.target.checked, user);
        // props.onChange(user,event.target.checked)
        // setChecked(event.target.checked);
    };

    const couponStateFilter = (usersNew, couponStateFilterId) => {
        // console.log('usersNew',usersNew, couponStateFilterId);
        // console.log('couponStateFilter usersNew,couponStateFilterI', usersNew,couponStateFilterId);
        switch (parseInt(couponStateFilterId)) {
            case 1:
                return usersNew.filter( c => !c.checked)
            case 2:
                return usersNew.filter( c => c.checked)
            case 3:
                return usersNew
        }


    };

    const customerTypeFilter = (usersNew, customerTypeFilterId) => {
        switch (customerTypeFilterId) {
            case 0:
                return _.filter(usersNew, (c) => { return c.customertype_id !== 'team' })
            case 1:
                return _.filter(usersNew, (c) => { return c.customertype_id === 'team' })
            case 2:
                return usersNew
        }

    };

    const getColapseStae = (checked) => {
        // console.log('getColapseStae', checked, props.couponStateFilter);
        switch (props.couponStateFilter) {
            case 1:
                return checked ? true : false
            case 2:
                return checked ? false : true
            case 3:
                return true
        }

    }

    //   Изменение фильтров
    useEffect(() => {
        setUsers(filterUsers(props.couponStateFilter, props.customerTypeFilter))

        // setCouponStateFilter(props.couponStateFilter)
    }, [props.couponStateFilter, props.customerTypeFilter]);


    return (

        
        <Card
            className={classes.card}
        >
            <CardContent className={classes.content}>
        {
            users && users.length >0 &&

                <PerfectScrollbar>
                    <div className={classes.inner}>
                        <List dense={true}>
                            {/* {JSON.stringify(users)} */}
                            {_.sortBy(users, 'user_name', 'asc').map(c => (
                            // {users.map(c => (
                                <React.Fragment
                                    key={c.user_id}
                                >

                                    <Collapse
                                        in={getColapseStae(!c.checked)}
                                        timeout={{ exit: 400, enter: 400 }}
                                    >
                                        <React.Fragment>
                                            <ListItem>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justify="flex-start"
                                                    alignItems="center"
                                                    spacing={1}
                                                >
                                                    <Grid
                                                        item
                                                        xs={8}>
                                                        <Typography variant="h5" component="h2" style={c.checked ? { textDecoration: 'line-through',fontWeight:600 } : {fontWeight:600}}>
                                                            {
                                                                c.customertype_id === 'team' &&
                                                                '😻 '
                                                            }
                                                            {
                                                                c.customertype_id === 'special' &&
                                                                '🔥 '
                                                            }
                                                             {c.user_name}
                                                        </Typography>
                                                        <Typography variant="h6" component="h3" style={c.checked ? { textDecoration: 'line-through', fontWeight:300 } : {fontWeight:300}}>
                                                            {c.meals.reduce( (agg, m) => {
                                                                // const res = agg + ' ' +  m.mealName
                                                                return `${agg} ${m.mealName} - ${m.amount}, ` 
                                                            },'').slice(0, -2) }
                                                        </Typography>


                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justify="flex-end"
                                                            alignItems="center"
                                                        >
                                                            <Checkbox
                                                                edge="end"
                                                                onChange={handleChange({userId: c.user_id, checked: c.checked})}
                                                                checked={c.checked}
                                                                // disabled={true}
                                                            // inputProps={{ 'aria-labelledby': labelId }}
                                                            />
                                                            {/* {
                                                                c.couponsList.map(cl => (

                                                                    <Grid
                                                                        item
                                                                        key={cl.id}
                                                                    >
                                                                        <Checkbox
                                                                            edge="end"
                                                                            onChange={handleChange(cl)}
                                                                            checked={cl.checked}
                                                                            // disabled={true}
                                                                        // inputProps={{ 'aria-labelledby': labelId }}
                                                                        />
                                                                    </Grid>
                                                                ))

                                                            } */}

                                                        </Grid>
                                                    </Grid>

                                                </Grid>

                                            </ListItem>
                                            <Divider component="li" />
                                        </React.Fragment>
                                    </Collapse>
                                </React.Fragment>
                            ))}


                        </List>
                    </div>
                </PerfectScrollbar>
        }
            </CardContent>
        </Card>

    
    );
};

export default UsersList;